module.exports = __webpack_public_path__ + "img/mail-active.d2fd5a5f.svg";